export const impact = [
  { name: 'accountability', value: false },
  { name: 'availability', value: false },
  { name: 'confidentiality', value: false },
  { name: 'integrity', value: false }
];

export const easeOfResolution = [
  { name: 'trivial', desc: 'Trivial' },
  { name: 'simple', desc: 'Simple' },
  { name: 'moderate', desc: 'Moderate' },
  { name: 'difficult', desc: 'Difficult' },
  { name: 'infeasible', desc: 'Infeasible' }
];

export const severities = [
  { name: 'critical', desc: 'CRITICAL' },
  { name: 'high', desc: 'HIGH' },
  { name: 'medium', desc: 'MEDIUM' },
  { name: 'low', desc: 'LOW' },
  { name: 'informational', desc: 'INFORMATIONAL' },
  { name: 'unclassified', desc: 'UNCLASSIFIED' }
];

export const vulnerabilityTypes = [
  { name: 'Vulnerability', desc: ' Vulnerability' },
  { name: 'VulnerabilityWeb', desc: ' Web Vulnerability' }
];

export const products = [
  { name: 'Faraday', desc: 'Faraday' },
  { name: 'Metasploit', desc: 'Metasploit' },
  { name: 'Nessus', desc: 'Nessus' },
  { name: 'Acunetix', desc: 'Acunetix' },
  { name: 'Burp', desc: 'Burp' },
  { name: 'Canvas', desc: 'Canvas' },
  { name: 'Maltego', desc: 'Maltego' },
  { name: 'Core', desc: 'label' },
  { name: 'Nexpose', desc: 'Nexpose' },
  { name: 'Netsparker', desc: 'Netsparker' },
  { name: 'Retina', desc: 'Retina' },
  { name: 'Onapsis', desc: ' Platform' },
  { name: 'Qualys', desc: 'Qualys' },
  { name: 'Fortify', desc: 'Fortify' },
  { name: 'Checkmarx', desc: 'Checkmarx' },
  { name: 'Other', desc: 'Other' }
];

export const roles = [
  { name: 'admin', desc: 'Admin' },
  { name: 'pentester', desc: 'Pentester' },
  { name: 'asset_owner', desc: 'Asset Owner' },
  { name: 'client', desc: 'Client' },
  { name: 'workspace_admin', desc: 'Workspace Administrator' }
];

export const status = [
  { name: 'open', desc: 'Open' },
  { name: 'closed', desc: 'Closed' },
  { name: 're-opened', desc: 'Re-Opened' },
  { name: 'risk-accepted', desc: 'Risk-Accepted' }
];

export const tableMaxPages = 3;

export const methodOptions = [
  { name: 'GET', desc: 'GET' },
  { name: 'POST', desc: 'POST' },
  { name: 'PUT', desc: 'PUT' },
  { name: 'DELETE', desc: 'DELETE' },
  { name: 'PATCH', desc: 'PATCH' },
  { name: 'HEAD', desc: 'HEAD' },
  { name: 'CONNECT', desc: 'CONNECT' },
  { name: 'OPTIONS', desc: 'OPTIONS' }
];

export const toolOptions = [
  { value: 'jira', label: 'JIRA' },
  { value: 'servicenow', label: 'ServiceNow' },
  { value: 'gitlab', label: 'GitLab' },
  { value: 'whd', label: 'Web Help Desk' }
];

export const cvssOptions = [
  { name: 'CVSS v2.0', desc: 'CVSS v2.0' },
  { name: 'CVSS v3.1', desc: 'CVSS v3.1' },
  { name: 'CVSS v4.0', desc: 'CVSS v4.0' }
];

export const optionsSortByWs = [
  { label: 'Importance', value: 'importance' },
  { label: 'Name', value: 'name' },
  { label: 'Creation Date', value: 'create_date' },
  { label: 'Last Modified', value: 'update_date' },
  { label: 'Permissions', value: 'readonly' },
  { label: 'Status', value: 'active' }
];

export const sortByWs = {
  importance: { id: 'importance', desc: true },
  name: { id: 'name', desc: false },
  create_date: { id: 'create_date', desc: true },
  update_date: { id: 'update_date', desc: true },
  readonly: { id: 'readonly', desc: false },
  active: { id: 'active', desc: false }
};
